<div class="right-navbar">
  <ul class="flex align-items-center">
    <li>
      <button
        type="button"
        class="theme-toggle-btn"
        (click)="toggleDarkMode()"
        [pTooltip]="isDarkMode ? 'Przełącz na tryb jasny' : 'Przełącz na tryb ciemny'"
        tooltipPosition="left"
      >
        <i [class]="isDarkMode ? 'pi pi-sun' : 'pi pi-moon'" style="font-size: 1.25rem"></i>
      </button>
    </li>
    <li [routerLink]="'user-config'">
      <i
        class="pi pi-cog"
        style="font-size: 1.25rem"
        tooltipPosition="left"
        [pTooltip]="'tooltips.settings' | translate"
      ></i>
    </li>
    <li (click)="openNotes()" role="presentation" tabindex="0" [rqaPermission]="['webrqa_user', 'webrqa_draw']">
      <i
        class="pi pi-file"
        style="font-size: 1.25rem"
        tooltipPosition="left"
        [pTooltip]="'tooltips.notes' | translate"
      ></i>
    </li>
    <li (click)="logout()" role="presentation" tabindex="0">
      <i
        class="pi pi-sign-out"
        [pTooltip]="'tooltips.logout' | translate"
        style="font-size: 1.25rem"
        tooltipPosition="left"
      ></i>
    </li>
  </ul>
</div>
